export enum TundrLogoVariant {
  LIGHT = 'light',
  DARK = 'dark',
  SMALL = 'small',
  SMALL_DARK = 'small_dark',
}
